// ARCHIVO GENERADO AUTOMÁTICAMENTE - NO EDITAR MANUALMENTE
// Generado el: 2026-11-05T13:21:06.857Z

export const hashedPasscodes = {};
